export const NewSolicitationInitialState = {
  requestTypeId: null,
  type: null,
  isBillPayment: false,
  isQuote: false,
  isConcierge: false,
  isHierarchy: false,
  clientId: null,
  clientDocument: null,
  productList: [],
  haveFavoriteSupplier: null,
  supplierId: null,
  supplierLabel: null,
  quoteFileUrl: null,
  quoteFileName: null,
  fileList: [],
  billingAddress: null,
  deliveryAddress: null,
};

export const SolicitationItemInitialState = {
  id: null,
  category: null,
  description: "",
  pointsValue: "",
  pointsTotalValue: "",
  quantity: "",
  subCategory: null,
  title: "",
  unitValue: "",
};

export const SolicitationAddressInitialState = {
  id: null,
  label: "",
  document: "",
  name: "",
  address: "",
  number: null,
  complement: "",
  neighborhood: "",
  zipCode: "",
  state: "",
  city: "",
};

export const ListSolicitationsInitialFilterState = {
  current: 1,
  pageSize: 10,
  statusId: null,
  term: null,
};

export const SolicitationDetailsInitialState = {
  details: {},
  actions: [],
  approvedQuotation: {},
  status: null,
  orders: [],
  solicitationItemsDetails: {},
  quotations: [],
  actionHistory: {},
  addresses: {},
};